import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const MapMarker2 = createSvgIcon(
  () => (
    <>
      <path d="M32.0003 26.6668C33.1736 26.6668 34.178 26.2491 35.0136 25.4135C35.8491 24.5779 36.2669 23.5735 36.2669 22.4002C36.2669 21.2268 35.8491 20.2224 35.0136 19.3868C34.178 18.5513 33.1736 18.1335 32.0003 18.1335C30.8269 18.1335 29.8225 18.5513 28.9869 19.3868C28.1514 20.2224 27.7336 21.2268 27.7336 22.4002C27.7336 23.5735 28.1514 24.5779 28.9869 25.4135C29.8225 26.2491 30.8269 26.6668 32.0003 26.6668ZM32.0003 48.0002C26.2758 43.1291 22.0003 38.6046 19.1736 34.4268C16.3469 30.2491 14.9336 26.3824 14.9336 22.8268C14.9336 17.4935 16.6491 13.2446 20.0803 10.0802C23.5114 6.91572 27.4847 5.3335 32.0003 5.3335C36.5158 5.3335 40.4891 6.91572 43.9203 10.0802C47.3514 13.2446 49.0669 17.4935 49.0669 22.8268C49.0669 26.3824 47.6536 30.2491 44.8269 34.4268C42.0003 38.6046 37.7247 43.1291 32.0003 48.0002Z" />
      <circle cx="31.9991" cy="54.4002" r="4.26667" />
    </>
  ),
  '0 0 64 64'
);
